export const DEFAULT_MAX_LETTER_COUNT = 130
export const DEFAULT_COLOR = '#EF6C00'
